import {
  FormGroup,
  Label,
  TextInput
} from './title-update-section.styles';

const TitleUpdateSection = ({ content = {}, metadata = {}, onChange }) => {
  const handleTextChange = (e) => {
    const text = e.target.value;
    onChange({
      content: { text },
      metadata: {}
    });
  };

  return (
    <FormGroup>
      <Label htmlFor="title-text">Section Title</Label>
      <TextInput
        id="title-text"
        type="text"
        value={content?.text || ''}
        onChange={handleTextChange}
        placeholder="Enter title text..."
      />
    </FormGroup>
  );
};

export default TitleUpdateSection;